// extracted by mini-css-extract-plugin
export var content = "FloatingPanel-module--content--vPBfx";
export var contentOpen = "FloatingPanel-module--contentOpen--PzpE3";
export var header = "FloatingPanel-module--header---0WBX";
export var iconButton = "FloatingPanel-module--iconButton--wltw-";
export var icons = "FloatingPanel-module--icons--A6Unt";
export var inner = "FloatingPanel-module--inner--Mmif2";
export var left = "FloatingPanel-module--left--oUTMv";
export var panel = "FloatingPanel-module--panel--J+iVp";
export var right = "FloatingPanel-module--right--I8EDC";